import networkvideo from "../../../../assets/videos/blogs/pp29/network.mp4";
import networkheaders from "../../../../assets/images/blogs/pp29/network-headers.png";
import networkoverview from "../../../../assets/images/blogs/pp29/network-overview.png";
import networkrequests from "../../../../assets/images/blogs/pp29/network-requests.png";
import networkstats from "../../../../assets/images/blogs/pp29/network-stats.png";
import networkfilter from "../../../../assets/images/docs/network/filter.png";
import * as React from 'react';
export default {
  networkvideo,
  networkheaders,
  networkoverview,
  networkrequests,
  networkstats,
  networkfilter,
  React
};